<template>
    <div v-if="modalOpen || modalInfo.isVisible">
        <div class="overlay" v-if="modalInfo.buttons.length > 1" @click="closeModalInfo"></div>
        <div class="overlay" v-else @click="handleButtonAction(modalInfo.buttons[0].buttonAction)"></div>
        <div class="modal-container">
            <div class="modal-title">
                <i :class="modalInfo.icon"></i>
            </div>
            <div class="modal-body">{{ modalInfo.text }}</div>
            <div class="modal-footer">
                <button v-for="(btn, btnkey) in modalInfo.buttons" :key="btnkey" @click="handleButtonAction(btn.buttonAction)" v-text="btn.buttonText"></button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
    name: 'ModalInfo',
    props: ['modalOpen'],
    components: {},
    data () {
        return {}
    },
    computed: {
        ...mapGetters(['modalInfo'])
    },
    methods: {
        ...mapActions(['closeModalInfo']),
        handleButtonAction: function (btnAction) {
            if (btnAction) {
                this.$emit(btnAction)
            }
            if (this.modalInfo.isVisible) {
                this.closeModalInfo()
            }
        }
    }
}
</script>

<style lang="less" scoped>
.modal-container {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    margin: auto 30px;
    border-radius: 10px;
    z-index: 3;
    box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.1);
    display: grid;
    grid-template-rows: 50px 1fr 50px;
    background-color: var(--backgroundColor);
    height: max-content;
    .modal-title {
        display: flex;
        align-items: flex-end;
        justify-content: center;
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
        font-size: 2rem;

        i {
          color: var(--iconColor)
        }
    }
    .modal-body {
        display: flex;
        align-items: center;
        text-align: center;
        justify-content: center;
        margin-top: 20px;
        margin-bottom: 20px;
        padding: 0 10px;
        word-break: break-word;
        white-space: pre-line;
    }
    .modal-footer {
        display: flex;
        align-items: center;
        justify-content: space-evenly;
        border-bottom-left-radius: 10px;
        border-bottom-right-radius: 10px;
        button {
            color: var(--buttonText);
            background: var(--buttonBackground);
            padding: 5px 10px;
            border: none;
            border-radius: 5px;
            font-size: 1rem;
            min-width: 90px;
        }
    }
}

@media (min-width: 769px) {
  .modal-container {
    width: 50%;
    margin: auto;
  }
}

.overlay {
        position: fixed;
        top: 0; left: 0;
        height: 100vh;
        width: 100vw;
        overflow: hidden;
        background: var(--backgroundColorOverlay);
        z-index: 2;
    }
</style>
